import { ShowOutlined } from '@duxton-web/icons';
import {
  Button, Flex, Modal, Typography,
} from '@duxton-web/ui';
import { QRCodeSVG } from 'qrcode.react';
import React, { useState } from 'react';

import { contentConfigModalStyle } from './theme';

// Eye trigger that opens the deep link as a scannable QR code. The code is
// encoded in the browser, so the deep link is never sent anywhere to render it,
// and scanning opens the value verbatim. Renders nothing without a value, so
// callers can pass an unset deep link unconditionally.
const DeeplinkQr = ({ deeplink, label = '' }) => {
  const [open, setOpen] = useState(false);
  if (!deeplink) return null;

  const title = label ? `${label} deep link` : 'Deep link';
  return (
    <React.Fragment>
      <Button
        size="small"
        type="text"
        className="cc-deeplink-qr-trigger"
        icon={<ShowOutlined />}
        aria-label={`Show QR code for the ${title}`}
        onClick={() => setOpen(true)}
      />
      <Modal
        title={title}
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={360}
        style={contentConfigModalStyle}
      >
        <Flex vertical align="center" gap={16} className="cc-deeplink-qr">
          <QRCodeSVG value={deeplink} size={220} />
          <Typography.Metadata>{deeplink}</Typography.Metadata>
        </Flex>
      </Modal>
    </React.Fragment>
  );
};

export default DeeplinkQr;
